<template>
  <div class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form" @click.stop="">
      <h2 class="editor-header">{{ companyUpdate.id > 0 ? $t('companies.edit') : $t('companies.add') }}</h2>
      <div class="col-sm-12 form-data">
        <span class="span-title">
          {{ $t('companies.name') }}
        </span>
          <div class="input-group">
              <input
                  id="companyname"
                  v-model="companyUpdate.name"
                  type="text"
                  class="form-control form-control-sm"
                  autocomplete="off"
                  :class="{'is-valid': companyUpdate.name && companyUpdate.name.length > 2}"
                  @keydown.down="onArrowDown"
                  @keydown.up="onArrowUp"
                  @keydown.enter="onEnter"
              />
              <button
                  class="btn btn-info btn-sm"
                  type="button"
                  :disabled="!companyUpdate.name || companyUpdate.name.length < 4"
                  @click="fetchCompanies"
              >
                  {{ $t('common.search') }}
              </button>
          </div>
          <ul
            v-show="showCompanies"
            ref="scrollContainer"
            class="autocomplete-results"
          >
            <li
              v-for="(company, i) in companies"
              ref="options"
              :key="i"
              :class="{ 'is-active': i === arrowCounter }"
              class="autocomplete-result"
              @click="setCompany(company)"
            >
              {{ company.names[0].name }}
            </li>
          </ul>
          <span class="span-title">
          {{ $t('companies.display_name') }}
        </span>
          <input
              id="display_name"
              v-model="companyUpdate.display_name"
              type="text"
              class="form-control form-control-sm"
              :class="{'is-valid': companyUpdate.display_name && companyUpdate.display_name.length > 7}"
          />
          <div class="row">
              <div class="col-6">
                 <span class="span-title">
                   {{ $t('companies.business_id') }}
                 </span>
                  <input
                      id="business_id"
                      v-model="companyUpdate.business_id"
                      type="text"
                      class="form-control form-control-sm"
                      :class="{'is-valid': companyUpdate.business_id !== null && companyUpdate.business_id.length > 7}"
                  />
              </div>
              <div class="col-6">
                  <span class="span-title">
                    {{ $t('companies.vat_id') }}
                  </span>
                  <input
                      id="vat_id"
                      v-model="companyUpdate.vat_id"
                      type="text"
                      class="form-control form-control-sm"
                  />
              </div>
          </div>
        <span class="span-title">
          {{ $t('areas.location') }}
        </span>
          <div class="row">
              <div class="col-6">
                  <input
                      id="latitude"
                      v-model="companyUpdate.location.y"
                      type="number"
                      step="0.0000000000001"
                      placeholder="Latitude"
                      class="form-control form-control-sm my-1"
                      :class="{'is-valid': companyUpdate.location.y != null && companyUpdate.location.y >= 0}"
                  />
              </div>
              <div class="col-6">
                  <input
                      id="longitude"
                      v-model="companyUpdate.location.x"
                      type="number"
                      step="0.0000000000001"
                      placeholder="Longitude"
                      class="form-control form-control-sm my-1"
                      :class="{'is-valid': companyUpdate.location.x != null && companyUpdate.location.x >= 0}"
                  />
              </div>
          </div>
        <h2>
          {{ $t('companies.address') }}
        </h2>
        <span class="span-title">
          {{ $t('companies.street') }}
        </span>
        <input
              id="street"
              v-model="address.street_address"
              type="text"
              class="form-control form-control-sm"
        />
        <div class="row">
            <div class="col-4">
                <span class="span-title">{{ $t('companies.postal') }}</span>
                <input
                    id="postal"
                    v-model="address.postal"
                    type="text"
                    class="form-control form-control-sm"
                />

            </div>
            <div class="col-8">
                <span class="span-title">{{ $t('companies.city') }}</span>
                <input
                    id="city"
                    v-model="address.city"
                    type="text"
                    class="form-control form-control-sm"
                />
            </div>
        </div>
        <h2>
          {{ $t('companies.invoicing_address') }}
        </h2>
        <span class="span-title">
          {{ $t('companies.work_order') }}
        </span>
        <input
              id="work_order"
              v-model="companyUpdate.work_order"
              type="text"
              class="form-control form-control-sm"
        />
        <span class="span-title">
          {{ $t('companies.street') }}
        </span>
        <input
              id="invoicing_street"
              v-model="invoicing_address.street_address"
              type="text"
              class="form-control form-control-sm"
        />
          <div class="row">
              <div class="col-4">
                  <span class="span-title">{{ $t('companies.postal') }}</span>
                  <input
                      id="invoicing_postal"
                      v-model="invoicing_address.postal"
                      type="text"
                      class="form-control form-control-sm"
                  />

              </div>
              <div class="col-8">
                  <span class="span-title">{{ $t('companies.city') }}</span>
                  <input
                      id="invoicing_city"
                      v-model="invoicing_address.city"
                      type="text"
                      class="form-control form-control-sm"
                  />
              </div>
          </div>

          <span class="span-title">
              {{ $t('companies.invoicing_net') }}
          </span>
          <input
              id="invoicing_net_operator"
              v-model="companyUpdate.invoicing_net_operator"
              type="text"
              class="form-control form-control-sm"
          />

          <span class="span-title">
              {{ $t('companies.invoicing_code') }}
          </span>
          <input
              id="invoicing_net_code"
              v-model="companyUpdate.invoicing_net_code"
              type="text"
              class="form-control form-control-sm"
          />


          <span class="span-title">
    {{ $t('companies.logo') }}
</span>
          <div v-if="photo" class="d-flex flex-column align-items-center mb-3">
              <img
                  :src="photoUrl"
                  alt="Photo"
                  class="photo-preview"
              />
              <button
                class="btn btn-outline-danger btn-sm mt-2"
                type="button"
                @click="triggerPhotoInput"
              >
                {{ $t('equipment_actions.replace') }}
              </button>
          </div>

          <!-- Hidden file input -->
          <input
              ref="photoInput"
              type="file"
              accept="image/jpeg,image/jpg,image/png"
              class="visually-hidden"
              @change="handlePhotoChange"
          />

          <!-- Custom "Add photo" button -->
          <div class="col-12 d-flex justify-content-end mt-3">
              <button
                  v-if="!photo"
                  class="btn btn-outline-primary btn-sm"
                  type="button"
                  :disabled="photo"
                  @click="triggerPhotoInput"
              >
                  {{ $t('common.add_photo') }}
              </button>
          </div>
          <div v-if="companyPreferences">
              <h2>
                  {{ $t('companies.settings') }}
              </h2>
              <span class="span-title">
                    {{ $t('companies.observation_report_title') }}
              </span>
              <input
                  v-model="companyPreferences.value.observationReportTitle"
                  placeholder="Report Title"
                  class="form-control form-control-sm"
              />
          </div>
          <div class="col-sm-12 button-container">
          <button
            class="btn btn-secondary form-button"
            @click.stop="$emit('close')"
          >
              {{ $t('common.cancel') }}
          </button>
          <button
            class="btn btn-success form-button"
            :disabled="loading"
            @click.stop="submitCompany"
          >
              {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import {geoCoder} from '../mixins/GeocodingMixin'
import {inject} from "vue";

export default {
    name: 'CompanyEditor',
    mixins: [workManagementHelper, restApi, geoCoder],
    props: {
        company: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            showCompanies: false,
            arrowCounter: -1,
            loading: false,
            companyUpdate: this.newCompany(this.company),
            prhUrl:'https://avoindata.prh.fi/opendata-ytj-api/v3/companies?',
            photo: null,
            photoChanged: false,
            photoUrl: null,
            companies: [],
            selectedCompany: null,
            address: {
                street_address: undefined,
                postal: undefined,
                city: undefined
            },
            invoicing_address: {
                street_address: undefined,
                postal: undefined,
                city: undefined
            },
            companyPreferences: {
                id: "",
                company_id: "",
                value: {
                    observationReportTitle: ""
                }
            }
        }
    },
    mounted: function () {
        this.photo = this.companyUpdate && this.companyUpdate.photo ? this.companyUpdate.photo : null
        if(this.photo) {
            this.fetchCompanyLogo()
        }
        this.address = (this.companyUpdate.address === undefined) ? this.address : this.companyUpdate.address
        this.invoicing_address = (this.companyUpdate.invoicing_address === undefined) ? this.invoicing_address : this.companyUpdate.invoicing_address
        if (this.company.id > 0) {
            this.fetchCompanyPreferences()
        }
        document.addEventListener('click', this.handleClickOutside);
    },
    unmounted() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        fetchCompanies() {
            if (this.companyUpdate.name) {
                this.clearValues()
                this.restFetchOpenData(this.prhUrl, {name: this.companyUpdate.name}, this.handleDataResponse)
            }
        },
        handleDataResponse:function (response) {
            if (response === null) {
                this.companyUpdate.business_id = null
                this.companyUpdate.vat_id = null
                this.companies = []
            }else{
                this.companies = response.data.companies
                this.showCompanies = true;
            }
        },
        fetchCompanyPreferences: function () {
            this.loading = true

            const url = `${this.companyUrl}/${this.company.id}/preferences`

            this.restFetch(url, this.handleCompanyPreferenceResponse)
        },
        handleCompanyPreferenceResponse: function (response) {
            if (response.data) {
                this.companyPreferences.id = response.data.id || ""
                this.companyPreferences.company_id = response.data.company_id || ""

                // Preserve the value structure, merge with API data
                if (response.data.value && typeof response.data.value === 'object') {
                    this.companyPreferences.value = {
                        ...this.companyPreferences.value,
                        ...response.data.value
                    }
                }
            }
            this.loading = false
        },
        fetchCompanyLogo() {
            this.restFetch(this.companyUrl + '/' + this.companyUpdate.id + '/photo', this.handlePhotoSuccess)
        },
        handlePhotoSuccess(response) {
            this.photoUrl = response.data
        },
        getAddressCoordinates: function (address) {
            address = this.addressToString(address)
            this.addressToCoordinates(address, this.handleAddressCoordinatesSuccess)
        },
        handleAddressCoordinatesSuccess: function (response) {
            if (response){
                this.companyUpdate.location = response
            }
        },
        addressToString(address) {
            return address.street_address + " " + address.postal + " " + address.city;
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.arrowCounter = -1;
                this.showCompanies = false;
            }
        },
        onArrowDown() {
            if (this.arrowCounter < this.companies.length-1) {
                this.arrowCounter = this.arrowCounter + 1;
                this.fixScrolling();
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
                this.fixScrolling();
            }
        },
        getPhotoPreview(file) {
            return URL.createObjectURL(file);
        },
        triggerPhotoInput() {
            this.$refs.photoInput.click();
        },
        handlePhotoChange(event) {
            const file = event.target.files[0];
            const maxSizeInBytes = 1 * 1024 * 1024; // 1 MB
            if (file) {
                if (file.size > maxSizeInBytes) {
                    this.showAlert(this.$t('common.file_too_large'));
                } else {
                    this.photo = file;
                    this.photoUrl = this.getPhotoPreview(file)
                    this.photoChanged = true
                }
            }
            this.$refs.photoInput.value = ''; // Reset input
        },
        removePhoto() {
            this.photo = null;
        },
        fixScrolling(){
            if(!this.showCompanies) return
            const liH = this.$refs.options[this.arrowCounter].clientHeight;
            this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
        },
        onEnter() {
            this.companyUpdate.name = this.companies[this.arrowCounter].name;
            this.selectedCompany = this.companies[this.arrowCounter];
            this.arrowCounter = -1;
            this.showCompanies = false;
            this.setCompany(this.selectedCompany)
        },
        setCompany(resultCompany) {
            const name = resultCompany.names[0]
            this.companyUpdate.name = name.name;
            this.showCompanies = false;
            this.companyUpdate.business_id = resultCompany.businessId.value;
            let invoicingAddress, visitingAddress;
            let addresses = resultCompany.addresses
            if(addresses.length === 1){
                invoicingAddress = visitingAddress = addresses[0];
            }else if(addresses.length > 1){
                invoicingAddress = addresses.find(item => !item.endDate && item.type === 1)
                visitingAddress = addresses.find(item => !item.endDate && item.type === 2)
            }
            this.companies = []
            this.companyUpdate.address.street_address = visitingAddress?.street + " " + (visitingAddress?.buildingNumber ? visitingAddress.buildingNumber : '')
            this.companyUpdate.address.postal = visitingAddress?.postCode
            this.companyUpdate.address.city = visitingAddress?.postOffices && visitingAddress.postOffices.length > 0 ? visitingAddress.postOffices[0].city : ''
            this.companyUpdate.invoicing_address.street_address = invoicingAddress?.street + " " + (invoicingAddress?.buildingNumber ? invoicingAddress.buildingNumber : '')
            this.companyUpdate.invoicing_address.postal = invoicingAddress?.postCode
            this.companyUpdate.invoicing_address.city = invoicingAddress?.postOffices && invoicingAddress.postOffices.length > 0 ? invoicingAddress.postOffices[0].city : ''
            if (visitingAddress) {
                this.getAddressCoordinates(this.companyUpdate.address)
            }
        },
        clearValues() {
            this.companyUpdate.address.street_address = '';
            this.companyUpdate.address.postal = '';
            this.companyUpdate.address.city = '';
            this.companyUpdate.invoicing_address.street_address = '';
            this.companyUpdate.invoicing_address.postal = '';
            this.companyUpdate.invoicing_address.city = '';
            this.companyUpdate.location.x = null
            this.companyUpdate.location.y = null
            this.companyUpdate.work_order = null
            this.companyUpdate.invoicing_net_operator = null;
            this.companyUpdate.invoicing_net_code = null;
        },
        setDefaultValues: function (companyUpdate) {
            let company = JSON.parse(JSON.stringify(companyUpdate))
            if (company.name === '') {
                this.showAlert(this.$t('inspectable_editor.invalid_name'))
                return undefined
            }
            if (company.business_id === null || company.business_id === '') {
                this.showAlert(this.$t('companies.business_id_missing'))
                return undefined
            }
            if (this.address.street_address === undefined && this.address.postal !== undefined && this.address.city === undefined) {
                company.address = undefined
            } else {
                company.address = this.address
            }
            if (this.invoicing_address.street_address === undefined && this.invoicing_address.postal === undefined && this.invoicing_address.city === undefined) {
                company.invoicing_address = undefined
            } else {
                company.invoicing_address = this.invoicing_address
            }
            if(!this.companyUpdate.location || this.companyUpdate.location.x === null || this.companyUpdate.location.x === ""
                || this.companyUpdate.location.y === null || this.companyUpdate.location.y === "") {
                this.showAlert(this.$t('companies.coordinates_missing'))
                return undefined
            }
            return company
        },

        submitCompany: function () {
            var jsonCompany = this.setDefaultValues(this.companyUpdate)
            if (jsonCompany !== undefined) {
                this.loading = true
                if (this.company.id < 1) {
                    this.restAdd(this.companyUrl, jsonCompany, this.success, this.fail)
                } else {
                    this.restUpdate(this.companyUrl, jsonCompany, this.success, this.fail)
                }
            }
        },

        success: function (response) {
            if (this.companyPreferences.id) {
                this.updateCompanyPreferences(response.id)
            } else {
                this.saveCompanyPreferences(response.id)
            }

            let photo = this.getValidPhoto(this.photo)
            if (photo && this.photoChanged) {
                this.uploadPhoto(photo, response.id)
            } else {
                this.showAlert(this.$t('common.alert_add_success'), 'success')
                this.$emit('closeAndUpdate')
                this.loading = false
            }
        },

        saveCompanyPreferences: function (companyId) {
            // Only save if there are preferences to save
            if (this.companyPreferences.value.observationReportTitle) {
                const url = `${this.companyUrl}/${companyId}/preferences`
                this.restAdd(url, this.companyPreferences.value, this.preferencesSuccess, this.preferencesFail)
            }
        },

        updateCompanyPreferences: function (companyId) {
            if (this.companyPreferences.value.observationReportTitle) {
                const url = `${this.companyUrl}/${companyId}/preferences`
                this.restUpdate(url, this.companyPreferences.value, this.preferencesSuccess, this.preferencesFail)
            }
        },

        preferencesSuccess: function (response) {
            // Could add specific success handling here if needed
        },

        preferencesFail: function () {
            // Could show a warning but don't block the main flow
        },

        getValidPhoto: function (attachment) {
            if (attachment !== undefined && attachment !== null) {
                return attachment;
            }
            return null; // Return null if the attachment is invalid
        },
        uploadPhoto: function (photo, companyId) {
            if (photo) {
                this.loading = true;
                let formData = new FormData();
                formData.append('photo', photo);
                let url = `${this.companyUrl}/${companyId}/photo`;
                this.restPostWithFile(url, {}, formData, this.photoSuccess, this.fail);
            }
        },
        photoSuccess: function () {
            this.loading = false
            this.photoChanged = false
            this.showAlert(this.$t('common.alert_add_success'), 'success')
            this.$emit('closeAndUpdate')
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },
    }
}
</script>
<style>

.photo-preview {
    max-width: 300px; /* Maximum width of the photo */
    height: auto; /* Maintain aspect ratio */
    border: 2px solid #ddd; /* Optional border for aesthetics */
    margin-top: 10px; /* Optional margin for spacing */
}
.autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    min-height: 1em;
    max-height: 6em;
    overflow: auto;
}

.autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 6px 2px;
    font-size: .9em;
    cursor: pointer;
}
.autocomplete-result.is-active,
.autocomplete-result:hover {
    background-color: #4AAE9B;
    color: white;
}
</style>
